import { PolicyModel } from './../models/insurance/policy.model';
import {
  AddressBillingModel,
  AddressInsuranceModel,
  ContactBillingModel,
  ContactInsuranceModel,
  ContractModel,
  CustomerBillingModel,
  CustomerInsuranceModel,
  InstallmentModel,
  InteractionModel,
  PaymentInfoModel,
} from '@/app/shared/models';
import { refsService as refs } from '@/app/shared/refs.service';
import { i18n } from '@/plugins';

export class GenerateInteractions {
  private createInteraction(actionCode: string, actionDesc: string) {
    refs.modules.ticket.createInteraction(
      new InteractionModel(
        i18n.t(`action_code.${actionCode}`),
        i18n.t(`action_desc.${actionDesc}`)
      )
    );
  }

  private createInteractionWithComplementDesc(
    actionCode: string,
    actionDesc: string,
    complementDesc: string
  ) {
    refs.modules.ticket.createInteractionWithComplementDesc({
      model: new InteractionModel(
        i18n.t(`action_code.${actionCode}`),
        i18n.t(`action_desc.${actionDesc}`)
      ),
      complementDesc,
    });
  }

  public personalDataBilling(
    oldCustomer: CustomerBillingModel,
    newCustomer: CustomerBillingModel,
    valueTab: string
  ) {
    if (!refs._.isEqual(oldCustomer.Name, newCustomer.Name))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad11',
        'DE ' +
          oldCustomer.Name +
          ' PARA ' +
          newCustomer.Name +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldCustomer.Document, newCustomer.Document))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad12',
        'DE ' +
          oldCustomer.Document +
          ' PARA ' +
          newCustomer.Document +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldCustomer.Birthdate, newCustomer.Birthdate))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad16',
        'DE ' +
          (oldCustomer.Birthdate
            ? refs.moment(oldCustomer.Birthdate).format('DD/MM/YYYY')
            : '') +
          ' PARA ' +
          refs.moment(newCustomer.Birthdate).format('DD/MM/YYYY') +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldCustomer.Gender, newCustomer.Gender))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad43',
        'DE ' +
          oldCustomer.Gender +
          ' PARA ' +
          newCustomer.Gender +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
  }
  public personalDataAddressBilling(
    oldAddress: AddressBillingModel | undefined,
    newAddress: AddressBillingModel,
    valueTab: string
  ) {
    if (
      (!refs._.isEmpty(oldAddress?.PostalCode) ||
        !refs._.isEmpty(newAddress.PostalCode)) &&
      !refs._.isEqual(oldAddress?.PostalCode, newAddress.PostalCode)
    )
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad44',
        'DE ' +
          oldAddress?.PostalCode +
          ' PARA ' +
          newAddress.PostalCode +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldAddress?.Street, newAddress.Street))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad14',
        'DE ' +
          oldAddress?.Street +
          ' PARA ' +
          newAddress.Street +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldAddress?.Neighborhood, newAddress.Neighborhood))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad45',
        'DE ' +
          oldAddress?.Neighborhood +
          ' PARA ' +
          newAddress.Neighborhood +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldAddress?.Complement, newAddress.Complement))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad46',
        'DE ' +
          oldAddress?.Complement +
          ' PARA ' +
          newAddress.Complement +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldAddress?.Number, newAddress.Number))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad47',
        'DE ' +
          oldAddress?.Number +
          ' PARA ' +
          newAddress.Number +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (
      !refs._.isEqual(oldAddress?.SubdivisionCode, newAddress.SubdivisionCode)
    )
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad48',
        'DE ' +
          oldAddress?.SubdivisionCode +
          ' PARA ' +
          newAddress.SubdivisionCode +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldAddress?.City, newAddress.City))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad49',
        'DE ' +
          oldAddress?.City +
          ' PARA ' +
          newAddress.City +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
  }
  public personalDataContactBilling(
    oldContact: ContactBillingModel | undefined,
    newContact: ContactBillingModel,
    email = false,
    valueTab: string
  ) {
    if (
      newContact.Value &&
      !refs._.isEqual(oldContact?.Value, newContact.Value)
    )
      this.createInteractionWithComplementDesc(
        'ac1',
        email
          ? 'ad13'
          : refs.enums.ContactType[newContact.Type] ==
              refs.enums.ContactType.CellPhone.toString() ||
            refs.enums.ContactType[newContact.Type] == 'CellPhone'
          ? 'ad35'
          : 'ad15',
        'DE ' +
          (oldContact?.Value || '') +
          ' PARA ' +
          newContact.Value +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
  }
  public contract(
    oldContract: ContractModel,
    newContract: ContractModel,
    valueTab: string
  ) {
    if (!refs._.isEqual(oldContract.Value, newContract.Value))
      this.createInteractionWithComplementDesc(
        'ac2',
        'ad17',
        'DE ' +
          oldContract.Value +
          ' PARA ' +
          newContract.Value +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldContract.DueDate, newContract.DueDate))
      this.createInteractionWithComplementDesc(
        'ac2',
        'ad18',
        'DE ' +
          oldContract.DueDate +
          ' PARA ' +
          newContract.DueDate +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (
      !refs._.isEqual(
        refs.moment(oldContract.FinishDate || '').format('DD/MM/YYYY'),
        refs.moment(newContract.FinishDate || '').format('DD/MM/YYYY')
      )
    )
      this.createInteractionWithComplementDesc(
        'ac2',
        'ad19',
        'DE ' +
          oldContract.FinishDate +
          ' PARA ' +
          newContract.FinishDate +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (
      !refs._.isEqual(
        oldContract.NumberOfInstallments,
        newContract.NumberOfInstallments
      )
    )
      this.createInteractionWithComplementDesc(
        'ac2',
        'ad21',
        'DE ' +
          oldContract.NumberOfInstallments +
          ' PARA ' +
          newContract.NumberOfInstallments +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldContract.Frequency, newContract.Frequency))
      this.createInteractionWithComplementDesc(
        'ac2',
        'ad22',
        'DE ' +
          oldContract.Frequency +
          ' PARA ' +
          newContract.Frequency +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldContract.OurCode, newContract.OurCode))
      this.createInteractionWithComplementDesc(
        'ac2',
        'ad20',
        'DE ' +
          oldContract.OurCode +
          ' PARA ' +
          newContract.OurCode +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
  }
  public installment(
    oldInstallment: InstallmentModel,
    newInstallment: InstallmentModel,
    valueTab: string
  ) {
    const oldOriginalDueDate = oldInstallment.OriginalDueDate
      ? refs.moment(oldInstallment.OriginalDueDate).format('DD/MM/YYYY')
      : '';
    const newOriginalDueDate = newInstallment.OriginalDueDate
      ? refs.moment(newInstallment.OriginalDueDate).format('DD/MM/YYYY')
      : '';
    if (!refs._.isEqual(oldOriginalDueDate, newOriginalDueDate))
      this.createInteractionWithComplementDesc(
        'ac23',
        'ad56',
        'DE ' +
          oldOriginalDueDate +
          ' PARA ' +
          newOriginalDueDate +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
  }
  public paymentInfo(
    oldPaymentInfo: PaymentInfoModel[],
    newPaymentInfo: PaymentInfoModel[],
    valueTab: string
  ) {
    const textNewPayment: string[] = [];
    const textOldPayment: string[] = [];
    newPaymentInfo.map((newPayment) => {
      if (newPayment) {
        if (
          refs.enums.PaymentMethod[newPayment.PaymentMethod] ==
          refs.enums.PaymentMethod.Debit.toString()
        ) {
          const accountType = refs.static.accountTypes.filter((result) => {
            if (result.value == newPayment.Debit?.AccountType) return result;
          })[0];
          const dataNewPaymentDebit =
            'Ag: ' +
            newPayment.Debit?.BranchNumber +
            '-' +
            (newPayment.Debit?.BranchDigit ?? '') +
            ' ' +
            accountType.label +
            ': ' +
            newPayment.Debit?.AccountNumber +
            '-' +
            (newPayment.Debit?.AccountDigit ?? '');
          textNewPayment.push(dataNewPaymentDebit);
        } else if (
          refs.enums.PaymentMethod[newPayment.PaymentMethod] ==
          refs.enums.PaymentMethod.Credit.toString()
        ) {
          const newCardTruncated = this.verifyLengthCardTruncated(newPayment);
          textNewPayment.push('Cartão: ' + (newCardTruncated || ''));
        } else if (
          refs.enums.PaymentMethod[newPayment.PaymentMethod] ==
          refs.enums.PaymentMethod.BankSlip.toString()
        ) {
          textNewPayment.push('Boleto');
        } else if (
          refs.enums.PaymentMethod[newPayment.PaymentMethod] ==
          refs.enums.PaymentMethod.BRCode.toString()
        ) {
          textNewPayment.push('Pix');
        } else {
          textNewPayment.push('CobillingTIM: ' + newPayment.Description);
        }
      }
    });
    oldPaymentInfo.map((oldPayment) => {
      if (oldPayment) {
        if (
          refs.enums.PaymentMethod[oldPayment.PaymentMethod] ==
          refs.enums.PaymentMethod.Debit.toString()
        ) {
          const accountType = refs.static.accountTypes.filter((result) => {
            if (result.value == oldPayment.AccountType) return result;
          })[0];
          const dataOldPaymentDebit =
            'Ag: ' +
            oldPayment.BranchNumber +
            '-' +
            (oldPayment.BranchDigit ?? '') +
            ' ' +
            accountType.label +
            ': ' +
            oldPayment.AccountNumber +
            '-' +
            (oldPayment.AccountDigit ?? '');
          textOldPayment.push(dataOldPaymentDebit);
        } else if (
          refs.enums.PaymentMethod[oldPayment.PaymentMethod] ==
          refs.enums.PaymentMethod.Credit.toString()
        ) {
          textOldPayment.push('Cartão: ' + oldPayment.CardTruncatedNumber);
        } else if (
          refs.enums.PaymentMethod[oldPayment.PaymentMethod] ==
          refs.enums.PaymentMethod.BankSlip.toString()
        ) {
          textOldPayment.push('Boleto');
        } else if (
          refs.enums.PaymentMethod[oldPayment.PaymentMethod] ==
          refs.enums.PaymentMethod.BRCode.toString()
        ) {
          textOldPayment.push('Pix');
        } else {
          textOldPayment.push('CobillingTIM: ' + oldPayment.Description);
        }
      }
    });

    this.createInteractionWithComplementDesc(
      'ac3',
      'ad38',
      'DE ' +
        textOldPayment.join(' | ') +
        ' PARA ' +
        textNewPayment.join(' | ') +
        (valueTab ? ' (' + valueTab + ')' : '')
    );
  }

  private verifyLengthCardTruncated(newPaymentInfo: PaymentInfoModel) {
    switch (newPaymentInfo.Credit?.CardTruncatedNumber.length) {
      case 13:
        return (newPaymentInfo.CardTruncatedNumber =
          newPaymentInfo.Credit?.CardTruncatedNumber.substr(0, 6) +
          '***' +
          newPaymentInfo.Credit?.CardTruncatedNumber.substr(9, 12));
      case 14:
        return (newPaymentInfo.Credit.CardTruncatedNumber =
          newPaymentInfo.Credit.CardTruncatedNumber.substr(0, 6) +
          '****' +
          newPaymentInfo.Credit.CardTruncatedNumber.substr(10, 13));
      case 15:
        return (newPaymentInfo.Credit.CardTruncatedNumber =
          newPaymentInfo.Credit.CardTruncatedNumber.substr(0, 6) +
          '*****' +
          newPaymentInfo.Credit.CardTruncatedNumber.substr(11, 14));
      case 16:
        return (newPaymentInfo.Credit.CardTruncatedNumber =
          newPaymentInfo.Credit.CardTruncatedNumber.substr(0, 6) +
          '******' +
          newPaymentInfo.Credit.CardTruncatedNumber.substr(12, 15));
      default:
        return newPaymentInfo.Credit?.CardTruncatedNumber;
    }
  }

  public personalDataInsurance(
    oldCustomer: CustomerInsuranceModel,
    newCustomer: CustomerInsuranceModel,
    valueTab: string
  ) {
    if (!refs._.isEqual(oldCustomer.Name, newCustomer.Name))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad11',
        'DE ' +
          oldCustomer.Name +
          ' PARA ' +
          newCustomer.Name +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldCustomer.Document, newCustomer.Document))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad12',
        'DE ' +
          oldCustomer.Document +
          ' PARA ' +
          newCustomer.Document +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldCustomer.Birthdate, newCustomer.Birthdate))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad16',
        'DE ' +
          (oldCustomer.Birthdate
            ? refs.moment(oldCustomer.Birthdate).format('DD/MM/YYYY')
            : '') +
          ' PARA ' +
          newCustomer.Birthdate +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
  }
  public personalDataAddressInsurance(
    oldAddress: AddressInsuranceModel | undefined,
    newAddress: AddressInsuranceModel,
    valueTab: string
  ) {
    if (newAddress.PostalCode && !refs._.isEqual(oldAddress, newAddress))
      this.createInteractionWithComplementDesc(
        'ac1',
        'ad14',
        valueTab ? ' (' + valueTab + ')' : ''
      );
  }
  public personalDataContactInsurance(
    oldContact: ContactInsuranceModel | undefined,
    newContact: ContactInsuranceModel,
    email = false,
    valueTab: string
  ) {
    if (
      newContact.Value &&
      !refs._.isEqual(oldContact?.Value, newContact.Value)
    )
      this.createInteractionWithComplementDesc(
        'ac1',
        email ? 'ad13' : 'ad15',
        (email ? 'DE ' + oldContact?.Value + ' PARA ' + newContact.Value : '') +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
  }
  public policy(
    oldPolicy: PolicyModel,
    newPolicy: PolicyModel,
    valueTab: string
  ) {
    if (!refs._.isEqual(oldPolicy.OurCode, newPolicy.OurCode))
      this.createInteractionWithComplementDesc(
        'ac2',
        'ad17',
        'DE ' +
          oldPolicy.OurCode +
          ' PARA ' +
          newPolicy.OurCode +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
    if (!refs._.isEqual(oldPolicy.FinishDate, newPolicy.FinishDate))
      this.createInteractionWithComplementDesc(
        'ac2',
        'ad19',
        'DE ' +
          oldPolicy.FinishDate +
          ' PARA ' +
          newPolicy.FinishDate +
          (valueTab ? ' (' + valueTab + ')' : '')
      );
  }
}
